import styled from 'styled-components';
import AntdModal from '../../../AntdModal';

const StyledExportModal = styled(AntdModal)`
  .ant-picker {
    width: 100%;
  }
  .ant-space {
    text-align: center;
    width: 100%;
  }
`;

const StyledExportModalBlockedMessage = styled.div`
  padding-top: 24px;
`;


export {
  StyledExportModal,
  StyledExportModalBlockedMessage,
}
